import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealerApi } from "../services/dealer.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  DEALER_MESSAGES_ERROR,
  DEALER_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableDealer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => dealerApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(DEALER_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(DEALER_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["dealers"] });
    },
    onError: () => {
      errorNotification(DEALER_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisableDealer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => dealerApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(DEALER_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(DEALER_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["dealers"] });
    },
    onError: () => {
      errorNotification(DEALER_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
